import React, { useEffect, useState } from "react";
import gsap from "gsap";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Trusted Trucking Services Nationwide!",
      text: "Experience the best with us",
      buttonText: "More About Us",
      buttonLink: "/aboutus",
      image: "images/truck.svg",
    },
    {
      title: "SRT delivers freight on time, every time.!",
      text: "We deliver on time, every time.",
      buttonText: "Our Services",
      buttonLink: "/services",
      image: "images/truck.svg",
    },
    {
      title: "Focused on safety, efficiency, and affordability",
      text: "Ready to Ship?",
      buttonText: "Contact Us",
      buttonLink: "/contact",
      image: "images/truck.svg",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
  
    return () => clearInterval(interval);
  }, [slides.length]); // ✅ Fix: Include slides.length
  

  useEffect(() => {
    gsap.fromTo(
      ".slide-title",
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 1 }
    );
    gsap.fromTo(
      ".slide-text",
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 1, delay: 0.3 }
    );
    gsap.fromTo(
      ".slide-button",
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 1, delay: 0.6 }
    );
  }, [currentSlide]);

  return (
    <div className="hero-section" style={{ position: "relative", overflow: "hidden" }}>
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      >
        <source src="./images/videoplayback.mp4" type="video/mp4" />
        Your browser does not support HTML video.
      </video>

      {/* Slide Content */}
      <div
        id="slides"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          zIndex: 1,
        }}
      >
        {slides.map((slide, index) => (
          <div key={index} className={`slide ${index === currentSlide ? "active" : "hidden"}`}>
            <h1 className="slide-title text-white">
              {slide.title}
              <span className="sh-underline">
                <img className="sh-truck" src={slide.image} alt="icon" width="60px" />
              </span>
            </h1>
            <p className="slide-text text-white">{slide.text}</p>
            <div className="slide-button">
              <Link to={slide.buttonLink} className="default-btn">
                {slide.buttonText}
              </Link>
            </div>
          </div>
        ))}
      </div>

      {/* Dark Overlay for Better Text Visibility */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 0,
        }}
      />
    </div>
  );
};

export default HeroSection;
